@layer design-system {
  .linePlotPath {
    fill: none;
    stroke: currentColor;
  }

  .circle {
    fill: currentColor;
    stroke: var(--background-default);
  }
}
